import { Button } from "@/components/ui/button";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuTrigger,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuCheckboxItem,
  DropdownMenuItem,
} from "@/components/ui/dropdown-menu";
import { Eye, ArrowsOutLineHorizontal } from "@phosphor-icons/react";

// Lightweight dropdown that toggles per-column visibility for the task table.
// `columns` = [{ key, label }], `hiddenSet` = Set<string>, `onToggle(key)`, `onShowAll`, `onResetWidths`.
export default function ViewMenu({ columns, hiddenSet, onToggle, onShowAll, onResetWidths }) {
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button
          variant="outline"
          size="sm"
          className="h-9 rounded-md border-slate-300 hover:border-slate-400 text-slate-700 font-medium"
          data-testid="view-menu-btn"
          title="Show / hide columns"
        >
          <Eye size={14} weight="bold" />
          <span className="ml-2">Show Columns</span>
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="rounded-md w-[230px]">
        <DropdownMenuLabel className="text-[10px] uppercase tracking-widest font-mono-ibm text-slate-500">
          Visible columns
        </DropdownMenuLabel>
        <DropdownMenuSeparator />
        {columns.map((c) => {
          const visible = !hiddenSet.has(c.key);
          return (
            <DropdownMenuCheckboxItem
              key={c.key}
              checked={visible}
              onCheckedChange={() => onToggle(c.key)}
              onSelect={(e) => e.preventDefault()}
              data-testid={`view-toggle-${c.key}`}
              className="text-xs"
            >
              {c.label}
            </DropdownMenuCheckboxItem>
          );
        })}
        <DropdownMenuSeparator />
        <DropdownMenuItem onClick={onShowAll} className="text-xs" data-testid="view-show-all">
          Show all columns
        </DropdownMenuItem>
        <DropdownMenuItem onClick={onResetWidths} className="text-xs" data-testid="view-reset-widths">
          <ArrowsOutLineHorizontal size={12} weight="bold" className="mr-2" />
          Reset widths
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
